import SubmitLoading from "@/utils/HelperComponent/SubmitLoading";
import { useMutation, useQuery } from "@apollo/client";
import { css } from "@emotion/react";
import axios from "axios";
import classnames from "classnames";
import { jwtDecode } from "jwt-decode";
import moment from "moment";
import { useEffect, useState } from "react";
import ReactExport from "react-export-excel";
import { MdOutlineDownloading } from "react-icons/md";
import { useHistory } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Modal,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import Swal from "sweetalert2";
import useGetWorkingDayQuery from "../../GraphQL/hooks/queries/useGetWorkingDayQuery";
import {
  CREATE_ATTENDANCE_BY_WEB,
  LOGOUT_ATTENDANCE,
} from "../../GraphQL/Mutation";
import {
  GET_ALL_ADDITIONAL_INFO_BY_USER_ID,
  GET_ATTENDANCE_BY_DATE_RFID,
  GET_USER_ATTENDANCE,
  SEARCH_ATTENDANCE_BETWEEN_DATE_AND_RFID,
} from "../../GraphQL/Queries";
import {
  loginInfo,
  paramsToObject,
  userAttendenceObject,
} from "../../utils/helpers";
import { decryption } from "../HelperFunctions";
import DownloadAttendanceReport from "../UserManagement/DownloadAttendanceReport";
import AttendanceForm from "./components/AttendanceForm";
import AttendanceTable from "./components/AttendanceTable";
import SearchForm from "./components/SearchForm";
import LunchPull from "./LunchPull";
import PenaltyRedZone from "./PenaltyRedZone";
import queryString from "query-string";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
import { useLocation } from "react-router-dom";
const Attendance = () => {
  const [workingDays, setWorkingDays] = useState({});
  const [allEmployees, setAllEmployees] = useState([]);
  const [isHomeOffice, setIsHomeOffice] = useState(false);
  const [attendanceToggle, setAttendanceToggle] = useState(false);
  const [loginStatus, setLoginStatus] = useState("logout");
  const loggedInfo = loginInfo();
  const [manualAttendanceToggle, setManualAttendanceToggle] = useState(false);
  const history = useHistory();
  //   ** get working day query
  const location = useLocation();

  const queryParams = new URLSearchParams(window.location.search);
  const fromDates = queryParams.get("fromDate");

  const toDates = queryParams.get("toDate");
  const searchUserId = queryParams.get("user_id");
  const searchType = queryParams.get("searchType");
  const searchPage = queryParams.get("page");
  const paramsData = paramsToObject(location.search);

  const [currentPage, setCurrentPage] = useState(Number(searchPage) || 1);

  const getUserByAttendance = useQuery(GET_USER_ATTENDANCE, {
    variables: {
      login_date: moment(new Date()).format("YYYY-MM-DD"),
      page: 1,
      size: 35,
    },
  });

  const userLoginStatus = useQuery(GET_ATTENDANCE_BY_DATE_RFID, {
    skip: !loggedInfo?.id,
    fetchPolicy: "cache-and-network",
    variables: {
      user_id: Number(loggedInfo?.id),
      login_date: moment(new Date()).format("YYYY-MM-DD"),
    },
  });

  useEffect(() => {
    userLoginStatus?.refetch();
    setLoginStatus(
      userLoginStatus?.data?.getAllAttendanceByDateAndRfid?.login_status,
    );
  }, [
    loginStatus,
    userLoginStatus?.data?.getAllAttendanceByDateAndRfid,
    attendanceToggle,
  ]);

  const [createAttendanceByWeb] = useMutation(CREATE_ATTENDANCE_BY_WEB);
  const [logoutAttendance] = useMutation(LOGOUT_ATTENDANCE);
  const [modal, setModal] = useState(false);
  const toggle = () => {
    setModal((prevState) => !prevState);
  };
  //add spinner fro loading
  let [color, setColor] = useState("rgb(54, 215, 183)");
  const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;
  // roles
  const roles = decryption(JSON.parse(localStorage?.getItem("roles")));

  const token = localStorage?.getItem("token");
  let userID;

  try {
    const decoded = jwtDecode(token);

    // Optional: Check for token expiry
    const isExpired = decoded.exp * 1000 < Date.now();

    if (isExpired) {
      localStorage.removeItem("token");
    } else {
      userID = decoded?.id;
    }
  } catch (err) {
    // Invalid token format
    localStorage.removeItem("token");
  }
  // login user information
  const loginUserInfo = useQuery(GET_ALL_ADDITIONAL_INFO_BY_USER_ID, {
    variables: { user_id: userID },
  });
  const todayDate = moment(new Date()).format("YYYY-MM-DD");
  // get previous date of month fron now start
  const prevDateOfMonth = new Date();
  const month = prevDateOfMonth.getMonth();
  prevDateOfMonth.setMonth(prevDateOfMonth.getMonth() - 1);
  while (prevDateOfMonth.getMonth() === month) {
    prevDateOfMonth.setDate(prevDateOfMonth.getDate() - 1);
  }
  // last weeek
  const firstDay = new Date();
  const [filteredAttendance, setFilteredAttendance] = useState([]);

  const [isLoadingAttendance, setIsLoadingAttendance] = useState(false);
  const previousweek = new Date(firstDay.getTime() - 7 * 24 * 60 * 60 * 1000);
  // const [fromDate, setFromDate] = useState(previousweek);
  const [fromDate, setFromDate] = useState(null);
  const [lastMonth, setLastmonth] = useState(prevDateOfMonth);
  const [isViewResult, setIsViewResult] = useState(false);

  const [lastWeek, setLastweek] = useState(previousweek);
  const [toDate, setToDate] = useState(null);
  // const [toDate, setToDate] = useState(new Date());
  const [allAttendances, setAllAttendances] = useState([]);
  // const LoadAllAttendcesByDate = useQuery(GET_ALL_ATTENDANCES_BY_DATE);
  // const LoadAllAttendces = useQuery(GET_ALL_ATTENDANCES);
  const [filterByUsername, setFilterByUsername] = useState(null);
  const [filterByAny, setFilterByAny] = useState(null);
  const [onSearch, setOnSearch] = useState(false);
  const [dailyAttendances, setDailyAttendances] = useState([]);
  const [userAttendance, setUserAttendance] = useState([]);

  // const [searchVars, setSearchVars] = useState({
  //   page: currentPage,
  //   size: 10,
  //   startedDate: toDates ? toDates : null,
  //   endDate: fromDates ? fromDates : null,
  //   user_id: searchUserId ? Number(searchUserId) : null,

  //   rfid: null,
  //   searchType: searchType ? Number(searchType) : null,
  // });

  const searchByDateAndRfid = useQuery(
    SEARCH_ATTENDANCE_BETWEEN_DATE_AND_RFID,
    {
      variables: {
        ...paramsData,
        // page: currentPage,
        size: 35,
        // startedDate: toDates ? toDates : null,
        // endDate: fromDates ? fromDates : null,
        // user_id: searchUserId ? Number(searchUserId) : null,

        // rfid: null,
        // searchType: searchType ? Number(searchType) : null,
      },
      skip: true,
      fetchPolicy: "cache-and-network",
      notifyOnNetworkStatusChange: true,
    },
  );

  const LoadWorkingDayData = useGetWorkingDayQuery({
    variables: {
      input: {
        start_date: new Date(moment(new Date()).format("YYYY-MM-DD")),
        end_date: new Date(moment(new Date()).format("YYYY-MM-DD")),
      },
    },
  });

  const searchOnchangeHandler = (event) => {
    setFilterByAny(event.target.value);
    setFilterByUsername(null);
  };

  useEffect(() => {
    const fetchAttendance = async () => {
      // setIsLoadingAttendance(true);
      const today = moment().format("YYYY-MM-DD");

      if (
        roles?.includes("System Admin") ||
        roles?.includes("Human Resource (HR)") ||
        roles?.includes("Head Of Department")
      ) {
        // Refetch for admin-like roles
        await searchByDateAndRfid.refetch({
          page: currentPage,
          size: 10,
          user_id: searchUserId ? Number(searchUserId) : null,
          rfid: null,
          searchType: searchType ? Number(searchType) : null,
          startedDate: today,
          endDate: today,
        });

        const userList =
          getUserByAttendance?.data?.getUserByAttendance?.data || [];

        const formatted = userList.map((item, index) =>
          userAttendenceObject(item, index),
        );

        setDailyAttendances(getUserByAttendance?.data?.getUserByAttendance);
      } else {
        // Refetch for regular employee
        // updateURLParams({ page: currentPage, fromDate: today, toDate: today });

        const result = await searchByDateAndRfid.refetch({
          startedDate: today,
          endDate: today,
          page: 1,
          // user_id: loggedInfo?.id,
        });

        setUserAttendance(
          result?.data?.search_attendance_between_date_and_rfid?.data || [],
        );
      }

      setIsLoadingAttendance(false);
    };

    fetchAttendance();
  }, [
    attendanceToggle,
    searchByDateAndRfid?.data?.search_attendance_between_date_and_rfid?.length,
    getUserByAttendance?.data?.getUserByAttendance?.data,
  ]);

  useEffect(() => {
    const loadData = async () => {
      setWorkingDays(LoadWorkingDayData?.data);
    };

    loadData();
  }, [LoadWorkingDayData?.data]);

  // sorted function
  Array.prototype.sortBy = function (p) {
    return this.slice(0).sort(function (a, b) {
      return a[p] < b[p] ? 1 : a[p] > b[p] ? -1 : 0;
    });
  };

  const [filteredResults, setFilteredResults] = useState([]);

  // const searchResult = async (from, to, employeeId, searchType) => {
  //   setIsLoadingAttendance(true);
  //   setFilterByUsername(employeeId);

  //   if (
  //     roles?.includes("System Admin") ||
  //     roles?.includes("Human Resource (HR)") ||
  //     roles?.includes("Head Of Department")
  //   ) {
  //     if (!!searchType || !!employeeId) {
  //       if (employeeId && searchType == 1) {
  //         const tz = "Asia/Dhaka";

  //         const todayStr = moment.tz(tz).format("YYYY-MM-DD");

  //         const last7Str = moment
  //           .tz(tz)
  //           .subtract(7, "days")
  //           .format("YYYY-MM-DD");

  //         const result = await searchByDateAndRfid.refetch({
  //           ...searchVars,
  //           startedDate: last7Str,
  //           endDate: todayStr,
  //           user_id: employeeId,
  //           page: currentPage,
  //         });

  //         setIsLoadingAttendance(false);
  //         setFilteredAttendance({
  //           data: result?.data?.search_attendance_between_date_and_rfid,
  //           total:
  //             result?.data?.search_attendance_between_date_and_rfid
  //               ?.paginatorInfo,
  //         });
  //         return;
  //       }

  //       if (employeeId && searchType == 2) {
  //         const result = await searchByDateAndRfid.refetch({
  //           ...searchVars,
  //           startedDate: moment(lastMonth).format("YYYY-MM-DD"),
  //           endDate: moment(new Date()).format("YYYY-MM-DD"),
  //           user_id: employeeId,
  //           page: currentPage,
  //         });
  //         setIsLoadingAttendance(false);
  //         setFilteredAttendance({
  //           data: result?.data?.search_attendance_between_date_and_rfid,
  //           total:
  //             result?.data?.search_attendance_between_date_and_rfid
  //               ?.paginatorInfo,
  //         });
  //         return;
  //       }
  //       if (!employeeId && searchType === 1) {
  //         const tz = "Asia/Dhaka";

  //         const todayStr = moment.tz(tz).format("YYYY-MM-DD");

  //         const last7Str = moment
  //           .tz(tz)
  //           .subtract(7, "days")
  //           .format("YYYY-MM-DD");

  //         const result = await searchByDateAndRfid.refetch({
  //           ...searchVars,
  //           startedDate: last7Str,
  //           endDate: todayStr,
  //           user_id: null,
  //           page: currentPage,
  //         });
  //         setIsLoadingAttendance(false);
  //         setFilteredAttendance({
  //           data: result?.data?.search_attendance_between_date_and_rfid,
  //           total:
  //             result?.data?.search_attendance_between_date_and_rfid
  //               ?.paginatorInfo,
  //         });
  //         return;
  //       }
  //       if (!employeeId && searchType == 2) {
  //         const result = await searchByDateAndRfid.refetch({
  //           ...searchVars,
  //           startedDate: moment(lastMonth).format("YYYY-MM-DD"),
  //           endDate: moment(new Date()).format("YYYY-MM-DD"),
  //           user_id: null,
  //           page: currentPage,
  //         });
  //         setIsLoadingAttendance(false);
  //         setFilteredAttendance({
  //           data: result?.data?.search_attendance_between_date_and_rfid,
  //           total:
  //             result?.data?.search_attendance_between_date_and_rfid
  //               ?.paginatorInfo,
  //         });
  //         return;
  //       }

  //       if (employeeId) {
  //         const result = await searchByDateAndRfid.refetch({
  //           ...searchVars,
  //           startedDate: from ? moment(from).format("YYYY-MM-DD") : "",
  //           endDate: to ? moment(to).format("YYYY-MM-DD") : "",
  //           user_id: employeeId,
  //           page: currentPage,
  //         });

  //         setIsLoadingAttendance(false);
  //         setFilteredAttendance({
  //           data: result?.data?.search_attendance_between_date_and_rfid,
  //           total:
  //             result?.data?.search_attendance_between_date_and_rfid
  //               ?.paginatorInfo,
  //         });
  //       }
  //       if (searchType == 1) {
  //         if (employeeId) {
  //           const result = await searchByDateAndRfid.refetch({
  //             ...searchVars,
  //             startedDate: moment(lastWeek).format("YYYY-MM-DD"),
  //             endDate: moment(new Date()).format("YYYY-MM-DD"),
  //             user_id: employeeId,
  //             page: currentPage,
  //           });
  //           setIsLoadingAttendance(false);
  //           setFilteredAttendance({
  //             data: result?.data?.search_attendance_between_date_and_rfid,
  //             total:
  //               result?.data?.search_attendance_between_date_and_rfid
  //                 ?.paginatorInfo,
  //           });
  //         } else {
  //           const result = await searchByDateAndRfid.refetch({
  //             ...searchVars,
  //             startedDate: moment(lastWeek).format("YYYY-MM-DD"),
  //             endDate: moment(new Date()).format("YYYY-MM-DD"),
  //             page: currentPage,
  //           });
  //           setIsLoadingAttendance(false);
  //           setFilteredAttendance({
  //             data: result?.data?.search_attendance_between_date_and_rfid,
  //             total:
  //               result?.data?.search_attendance_between_date_and_rfid
  //                 ?.paginatorInfo,
  //           });
  //         }
  //       }
  //       if (searchType == 2) {
  //         if (employeeId) {
  //           const result = await searchByDateAndRfid.refetch({
  //             ...searchVars,
  //             startedDate: moment(lastMonth).format("YYYY-MM-DD"),
  //             endDate: moment(new Date()).format("YYYY-MM-DD"),
  //             user_id: employeeId,
  //             page: currentPage,
  //           });

  //           setIsLoadingAttendance(false);
  //           setFilteredAttendance({
  //             data: result?.data?.search_attendance_between_date_and_rfid,
  //             total:
  //               result?.data?.search_attendance_between_date_and_rfid
  //                 ?.paginatorInfo,
  //           });
  //         } else {
  //           const result = await searchByDateAndRfid.refetch({
  //             ...searchVars,
  //             startedDate: moment(lastMonth).format("YYYY-MM-DD"),
  //             endDate: moment(new Date()).format("YYYY-MM-DD"),
  //             page: currentPage,
  //           });
  //           setIsLoadingAttendance(false);
  //           setFilteredAttendance({
  //             data: result?.data?.search_attendance_between_date_and_rfid,
  //             total:
  //               result?.data?.search_attendance_between_date_and_rfid
  //                 ?.paginatorInfo,
  //           });
  //         }
  //       }
  //     } else {
  //       const result = await searchByDateAndRfid.refetch({
  //         ...searchVars,
  //         startedDate: from ? moment(from).format("YYYY-MM-DD") : "",
  //         endDate: to ? moment(to).format("YYYY-MM-DD") : "",
  //         user_id: null,
  //         page: currentPage,
  //       });
  //       setIsLoadingAttendance(false);
  //       setFilteredAttendance({
  //         data: result?.data?.search_attendance_between_date_and_rfid,
  //         total:
  //           result?.data?.search_attendance_between_date_and_rfid?.paginatorInfo
  //             ?.total,
  //       });
  //     }
  //   } else {
  //     const result = await searchByDateAndRfid.refetch({
  //       ...searchVars,
  //       startedDate: from ? moment(from).format("YYYY-MM-DD") : "",
  //       endDate: to ? moment(to).format("YYYY-MM-DD") : "",
  //       user_id: userID,
  //       page: currentPage,
  //     });

  //     setIsLoadingAttendance(false);
  //     setFilteredAttendance({
  //       data: result?.data?.search_attendance_between_date_and_rfid,
  //       total:
  //         result?.data?.search_attendance_between_date_and_rfid?.paginatorInfo
  //           ?.total,
  //     });
  //   }
  // };
  const searchResult = async (from, to, employeeId, searchType) => {
    console.log("employeeId: ", employeeId);
    setIsLoadingAttendance(true);
    setFilterByUsername(employeeId);

    const TZ = "Asia/Dhaka";
    const fmt = (d) => (d ? moment.tz(d, TZ).format("YYYY-MM-DD") : "");

    // pick date window
    const today = moment.tz(TZ).format("YYYY-MM-DD");
    let startedDate = "";
    let endDate = "";

    if (searchType === 1) {
      // weekly: last 7 days -> today
      startedDate = moment.tz(TZ).subtract(7, "days").format("YYYY-MM-DD");
      endDate = today;
    } else if (searchType === 2) {
      // monthly: month start -> today
      startedDate = moment.tz(TZ).startOf("month").format("YYYY-MM-DD");
      endDate = today;
    } else {
      // custom
      startedDate = fmt(from);
      endDate = fmt(to);
    }

    // who to filter by (frontend decides, since you said "dont use role" on backend)
    const isAdminLike =
      roles?.includes("System Admin") ||
      roles?.includes("Human Resource (HR)") ||
      roles?.includes("Head Of Department");

    const effectiveUserId = isAdminLike ? (employeeId ?? null) : userID;

    // build final variables
    const vars = {
      user_id: employeeId ?? null,
      rfid: null,
      searchType: searchType ? searchType : null,
      startedDate,
      endDate,
      page: 1,
      ...(effectiveUserId ? { user_id: Number(effectiveUserId) } : {}),
    };

    try {
      const result = await searchByDateAndRfid.refetch(vars);
      const payload = result?.data?.search_attendance_between_date_and_rfid;
      const rows = payload?.data || [];
      const paginatorInfo = payload?.paginatorInfo;

      setFilteredAttendance({
        data: rows,
        total: paginatorInfo,
      });
    } catch (e) {
      setFilteredAttendance({ data: [], total: null });
    } finally {
      setIsLoadingAttendance(false);
    }
  };

  const [excelData, setExcelData] = useState([]);
  useEffect(() => {
    setExcelData(
      filteredAttendance?.data?.data?.map((item, index) => {
        return {
          id: index + 1,
          name: item.employeeInfo?.user?.name
            ? item.employeeInfo?.user?.name
            : item?.userInfo?.name,
          rfid: item.rfid,
          username: item.employeeInfo?.user?.username
            ? item.employeeInfo?.user?.username
            : item?.userInfo?.username,
          user_ip: item.user_ip,
          login_date: item.login_date,
          login_time: item.login_time,
          logout_device: item.logout_device,
          logout_time: item.logout_time,
        };
      }),
    );
  }, [filteredAttendance?.total?.total]);

  // permission
  const permissions = decryption(
    JSON.parse(localStorage?.getItem("permissions")),
  );

  const placeAttendanceHandler = async () => {
    let userIP;

    // Step 1: Get the public IP address using Cloudflare trace
    await axios
      .get("https://www.cloudflare.com/cdn-cgi/trace")
      .then(function (response) {
        const ipData = response?.data
          .trim()
          .split("\n")
          .reduce(function (obj, pair) {
            pair = pair.split("=");
            return ((obj[pair[0]] = pair[1]), obj);
          }, {});
        userIP = ipData?.ip;
      });

    // Step 2: Ask for confirmation
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to place an attendance?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      denyButtonText: "No",
      customClass: {
        actions: "my-actions",
        cancelButton: "order-1 right-gap",
        confirmButton: "order-2",
        denyButton: "order-3",
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        // Step 3: Check IP before continuing
        if (userIP === "103.51.3.28" || userIP === "118.179.152.148") {
          // IP is allowed → Proceed with attendance
          const result = await createAttendanceByWeb({
            variables: {
              user_id: loggedInfo?.id,
              time: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
              user_ip: userIP,
            },
          });

          getUserByAttendance?.refetch();
          setAttendanceToggle((prev) => !prev);

          if (result?.data?.createAttendanceByWeb?.result_code === "000") {
            Swal.fire(
              "Success!",
              "Your attendance has been placed.",
              "success",
            );
          } else {
            Swal.fire(
              "Failed!",
              result?.data?.createAttendanceByWeb?.status,
              "error",
            );
          }
        } else {
          // IP is not allowed → Show error message
          Swal.fire(
            "Not Allowed",
            "You are not in the office and cannot place attendance now.",
            "error",
          );
        }
      }
    });
  };

  useEffect(() => {
    if (localStorage?.getItem("home_office")) {
      setIsHomeOffice(localStorage?.getItem("home_office"));
    }
  }, [attendanceToggle]);

  const officeLeaveHandler = async () => {
    let returnValue;
    await axios
      .get("https://www.cloudflare.com/cdn-cgi/trace")
      .then(function (response) {
        returnValue = response?.data
          .trim()
          .split("\n")
          .reduce(function (obj, pair) {
            pair = pair.split("=");
            return ((obj[pair[0]] = pair[1]), obj);
          }, {});
      });
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to leave office?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      denyButtonText: "No",
      customClass: {
        actions: "my-actions",
        cancelButton: "order-1 right-gap",
        confirmButton: "order-2",
        denyButton: "order-3",
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        const result = await logoutAttendance({
          variables: {
            user_id: loggedInfo?.id,
            time: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
            user_ip: returnValue?.ip,
          },
        });
        getUserByAttendance?.refetch();
        setAttendanceToggle((prevState) => !prevState);
        Swal.fire("Success!", "Successfully logout.", "success");
      }
    });
  };

  // const [activeTab, setActiveTab] = useState("1");

  // const toggleTab = (tab) => {
  //   if (activeTab !== tab) setActiveTab(tab);

  // };
  const [activeTab, setActiveTab] = useState(() => {
    const sp = new URLSearchParams(window.location.search);
    return sp.get("tab") ?? "1";
  });

  useEffect(() => {
    const sp = new URLSearchParams(window.location.search);
    if (activeTab === "1") sp.delete("tab");
    else sp.set("tab", activeTab);
    const url = `${window.location.pathname}${sp.toString() ? `?${sp}` : ""}`;
    window.history.replaceState(null, "", url);
  }, [activeTab]);

  const toggleTab = (tab) => setActiveTab(tab);
  //
  // ||
  //     userLoginStatus.loading ||
  //     loginUserInfo.loading ||
  //     isLoadingAttendance ||
  //     searchByDateAndRfid.loading ||
  //     LoadWorkingDayData.loading

  // console.log(
  //   "🚀 ~ Attendance ~ getUserByAttendance.loading:",
  //   getUserByAttendance.loading
  // );
  if (userLoginStatus.loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <SubmitLoading color="black" />
      </div>
    );
  }

  return (
    <>
      <Col md={12}>
        <div>
          {/* Other UI */}
          <PenaltyRedZone
            // penalties={data?.getAllPenaltyShowByUser?.data}
            // user={data}
            user_id={loggedInfo?.id}
          />
        </div>

        <Nav tabs className="justify-content-center">
          <NavItem>
            <NavLink
              style={{
                color: activeTab === "1" ? "#495057" : "#495057",
              }}
              className={classnames({ active: activeTab === "1" })}
              onClick={() => toggleTab("1")}
            >
              Attendance
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              style={{
                color: activeTab === "2" ? "#495057" : "#495057",
              }}
              className={classnames({ active: activeTab === "2" })}
              onClick={() => toggleTab("2")}
            >
              Lunch Pull
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">
            <Card>
              <CardBody>
                <Row>
                  <Col xs={6} md={4}>
                    <h3 className="page-title">Today's Attendance</h3>
                  </Col>
                  <Col xs={6} md={8}>
                    {excelData?.length > 0 ? (
                      <ExcelFile
                        element={
                          <button className="btn ml-2 btn-sm btn-primary float-right">
                            Report <MdOutlineDownloading className="mb-1" />
                          </button>
                        }
                      >
                        <ExcelSheet
                          data={excelData}
                          name={`Office_Attendance_${moment(new Date()).format(
                            "YYYY-MM-DD HH:mm:ss",
                          )}`}
                        >
                          <ExcelColumn label="SL" value="id" />
                          <ExcelColumn label="Name" value="name" />
                          <ExcelColumn label="RFID" value="rfid" />
                          <ExcelColumn label="User IP" value="user_ip" />
                          <ExcelColumn label="Login Date" value="login_date" />
                          <ExcelColumn label="Login Time" value="login_time" />
                          <ExcelColumn
                            label="Logout Device"
                            value="logout_device"
                          />
                          <ExcelColumn
                            label="Logout Time"
                            value="logout_time"
                          />
                        </ExcelSheet>
                      </ExcelFile>
                    ) : null}
                    {permissions?.includes("create_place_attendance") &&
                    loginStatus == "login" ? (
                      <button
                        onClick={() => {
                          officeLeaveHandler();
                        }}
                        className="btn btn-sm btn-danger float-right ml-2"
                      >
                        - Leave Office
                      </button>
                    ) : (
                      <button
                        onClick={() => {
                          placeAttendanceHandler();
                        }}
                        className="btn btn-sm btn-success float-right ml-2"
                      >
                        + Today
                      </button>
                    )}

                    {permissions?.includes("create_manual_attendance") && (
                      <button
                        onClick={() => {
                          toggle();
                        }}
                        className="btn btn-sm btn-success float-right ml-2"
                      >
                        + Manual
                      </button>
                    )}
                    {/* {permissions?.includes("attendance_report") && (
                      <DownloadAttendanceReport
                        data={
                          filteredAttendance?.data
                            ? filteredAttendance?.data
                            : dailyAttendances
                        }
                        login_date={moment(new Date()).format("YYYY-MM-DD")}
                      />
                    )} */}
                  </Col>
                </Row>
                <SearchForm
                  setFilterByUsername={setFilterByUsername}
                  filterByUsername={filterByUsername}
                  setFromDate={setFromDate}
                  setToDate={setToDate}
                  fromDate={fromDate}
                  toDate={toDate}
                  filterByAny={filterByAny}
                  userID={userID}
                  roles={roles}
                  searchResult={searchResult}
                  setFilteredResults={setFilteredResults}
                  filteredAttendance={filteredAttendance}
                  setOnSearch={setOnSearch}
                  setFilteredAttendance={setFilteredAttendance}
                  setIsViewResult={setIsViewResult}
                  isViewResult={isViewResult}
                  allEmployees={allEmployees}
                  setAllEmployees={setAllEmployees}
                  data={getUserByAttendance?.data}
                  todayCount={getUserByAttendance?.data?.getUserByAttendance?.data?.map(
                    (item, index) => userAttendenceObject(item, index),
                  )}
                  totalData={
                    getUserByAttendance?.data?.getUserByAttendance
                      ?.paginatorInfo?.total
                  }
                  workingDays={workingDays}
                  LoadWorkingDayData={LoadWorkingDayData}
                />

                {LoadWorkingDayData.loading ? (
                  <SubmitLoading color="black" />
                ) : isViewResult ? (
                  <AttendanceTable
                    roles={roles}
                    getUserByAttendance={getUserByAttendance}
                    refetch={searchByDateAndRfid}
                    data={searchByDateAndRfid}
                    setFilteredAttendance={setFilteredAttendance}
                    isLoadingAttendance={isLoadingAttendance}
                    allAttendances={filteredAttendance}
                    setCurrentPage={setCurrentPage}
                    currentPage={currentPage}
                    // setSearchVars={setSearchVars}
                    searchVars={paramsData}
                  />
                ) : (
                  <AttendanceTable
                    roles={roles}
                    isLoadingAttendance={isLoadingAttendance}
                    refetch={getUserByAttendance}
                    setCurrentPage={setCurrentPage}
                    currentPage={currentPage}
                    dailyAttendancesLoading={getUserByAttendance.loading}
                    // allAttendances={dailyAttendances}
                    setFilteredAttendance={setFilteredAttendance}
                    userAttendance={userAttendance}
                    getUserByAttendance={getUserByAttendance}
                    dailyAttendances={dailyAttendances}
                  />
                )}
              </CardBody>
            </Card>
          </TabPane>
          <TabPane tabId="2">
            <LunchPull user_id={loggedInfo?.id} />
          </TabPane>
        </TabContent>

        <Modal isOpen={modal} toggle={toggle}>
          <AttendanceForm
            toggle={toggle}
            allEmployees={allEmployees}
            refetch={getUserByAttendance?.refetch}
          />
        </Modal>
      </Col>
    </>
  );
};

export default Attendance;
